module.exports = __webpack_public_path__ + "img/s3.8705ad0f.png";